<template>
  <div>
    <Import
      title="Product and Services"
      :check_validation="'products/importproductvalidation'"
      :url="url"
      :items="items"
      @import="submit"
      :show_message="pdt_settings_details.allow_duplicate_pdt==true?'(This product will be mapped based on SKU as product name duplication is enabled)':''"
      :allow_duplicate_name="allow_duplicate_pdt"
      :sample_file_name="'sample-product-data.xlsx'"
      :warehouse_id="this.primary_warehouse_details.warehouse_id"
      :show_dup_handle="{
        show:true,
        value:0}"
        @redirectPage="redirectPage"
    ></Import>
  </div>
</template>
<script>
import Import from "@/components/Form/Import/Import";
import sample_data from "@/assets/sample-import-files/sample-product.xlsx";
import { mapState, mapGetters } from "vuex";
export default {
  components: { Import, sample_data },
  data() {
    return {
      url: sample_data,
      items: []
    };
  },
  created() {
    this.items = this.import_columns();
    if (this.org_details.gst_type == 1) {
      this.items.push(
        {
          actual_label: "Intra State Tax Rate Name",
          excel_label: "",
          unique: 0,
          field_name: "pdt_tax_name",
          is_required: true,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "Intra State Tax Rate",
          excel_label: "",
          unique: 0,
          field_name: "pdt_tax_id",
          is_required: true,
          datatype: "percent",
          max: 0,
          min: 0
        },
        {
          actual_label: "Inter State Tax Rate Name",
          excel_label: "",
          unique: 0,
          field_name: "pdt_inter_tax_name",
          is_required: true,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "Inter State Tax Rate",
          excel_label: "",
          unique: 0,
          field_name: "pdt_inter_tax_id",
          is_required: false,
          datatype: "percent",
          max: 0,
          min: 0
        },
        {
          actual_label: "Exemption Reason",
          excel_label: "",
          unique: 0,
          field_name: "exempt_reason",
          is_required: false,
          datatype: "text",
          max: 50,
          min: 0
        },
        {
          actual_label: "Inclusive of tax",
          excel_label: "",
          unique: 0,
          field_name: "pdt_tax_type",
          is_required: false,
          datatype: "select",
          max: 10,
          min: 0
        },
        {
          actual_label: "Is Taxable",
          excel_label: "",
          unique: 0,
          field_name: "is_taxable",
          is_required: false,
          datatype: "select",
          max: 0,
          min: 0
        }
      );
    }
    if (this.pdt_settings_details.custom_field.length > 0) {
      var temp = this;
      this.pdt_settings_details.custom_field.map(function(value) {
        if (value.created == 1 && value.status == 1) {
          temp.items.push({
            actual_label: value.label_name,
            excel_label: "",
            unique: 0,
            is_required: value.is_required == 1 ? true : false,
            field_name: value.field_name,
            datatype:
              value.datatype == "checkbox"
                ? "select"
                : value.datatype == "url" ||
                  value.datatype == "email" ||
                  value.datatype == "textarea"
                ? "text"
                : value.datatype,
            max:
              value.datatype == "decimal" || value.datatype == "amount"
                ? 10000000000000
                : value.datatype == "date" ||
                  value.datatype == "select" ||
                  value.datatype == "checkbox"
                ? ""
                : 100,
            min: value.datatype == "percent" ? 0 : ""
          });
        }
      });
    }
  },
  methods: {
     redirectPage(){
      this.$router.push({name:'Product'})
    },
    import_columns() {
      return [
        {
          actual_label: "Product Type",
          excel_label: "",
          unique: 0,
          field_name: "pdt_type",
          is_required: true,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "Product Name",
          excel_label: "",
          unique: this.pdt_settings_details.allow_duplicate_pdt ? 0 : 1,
          field_name: "pdt_name",
          is_required: true,
          datatype: "text",
          max: 150,
          min: 0
        },
        {
          actual_label: "Product legacy id",
          excel_label: "",
          unique: this.pdt_settings_details.allow_duplicate_pdt ? 0 : 1,
          field_name: "pdt_legacy_id",
          is_required: false,
          datatype: "text",
          max: 15,
          min: 0
        },
        {
          actual_label: "Unit",
          excel_label: "",
          unique: 0,
          field_name: "pdt_unit",
          is_required: true,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "SKU",
          excel_label: "",
          unique: 1,
          field_name: "pdt_sku",
          is_required: false,
          datatype: "text",
          max: 200,
          min: 0
        },
        {
          actual_label: "HSN/SAC",
          excel_label: "",
          unique: 0,
          field_name: "pdt_hsn",
          is_required: false,
          datatype: "text",
          max: 8,
          min: 0
        },
        {
          actual_label: "Selling Price",
          excel_label: "",
          unique: 0,
          field_name: "pdt_sal_price",
          is_required: true,
          datatype: "amount",
          max: 100000000000000,
          min: 0
        },
        {
          actual_label: "Sales Account",
          excel_label: "",
          unique: 0,
          field_name: "sales_account",
          is_required: false,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "Description",
          excel_label: "",
          unique: 0,
          field_name: "sales_desc",
          is_required: false,
          datatype: "text",
          max: 100,
          min: 0
        },

        {
          actual_label: "Product tag",
          excel_label: "",
          unique: 0,
          field_name: "pdt_tags",
          is_required: false,
          datatype: "array",
          max: 0,
          min: 0
        },

        {
          actual_label: "Status",
          excel_label: "",
          unique: 0,
          field_name: "pdt_status",
          is_required: false,
          datatype: "select",
          max: 0,
          min: 0
        }
      ];
    },
    submit() {
      this.$store.dispatch("products/importProduct", this.list).then(() => {
        this.$router.push({
          name: "Product"
        });
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: this.status_message,
          type:this.status_type,
          showCloseButton: true
        });
      });
    }
  },
  computed: {
    ...mapState({
      message: state => state.products.message,
      list: state => state.products.list,
      status_code: state => state.products.status_code,
      status_message: state => state.products.status_message,
      status_type: state => state.products.status_type
    }),
    ...mapGetters([
      "pdt_settings_details",
      "primary_warehouse_details",
      "org_details"
    ])
  }
};
</script>